import React from 'react';
import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

const Notification = ({ noti }) => {
    const colors = {
        success: {
            main: '#A7F0BA',
        },
        warning: {
            main: '#FFE17C',
        },
        error: {
            main: '#FF8389',
        },
    };

    const getIcon = (status) => {
        switch (status) {
            case 'success':
                return <TaskAltIcon style={{ color: colors.success.main }} />;
            case 'warning':
                return <ErrorOutlineIcon style={{ color: colors.warning.main }} />;
            default:
                return <HighlightOffIcon style={{ color: colors.error.main }} />;
        }
    };

    const style = colors[noti.status];

    return (
        <div style={{
            width: '400px',
            backgroundColor: '#000000',
            borderColor: style.main,
            borderWidth: '1px',
            borderStyle: 'solid',
            padding: '10px',
            color: '#FFFFFF',
            marginTop: '-50px',
            marginLeft: '-25px',
        }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                }}
            >

                <div style={{ marginRight: '10px' }}>
                    {getIcon(noti.status)}
                </div>

                <Box>
                    <Typography variant="h6" style={{ margin: 0 }}>
                        {noti.title}
                    </Typography>
                    <Typography variant="body2">
                        {noti.message}
                    </Typography>
                </Box>
            </Box>
        </div>
    );
};

export default Notification;
